{
  "button": "Help and feedback",
  "buttonShort": "Help",
  "sheet": {
    "title": "Need help?",
    "search": "Search help",
    "searchHint": "For example: reminders, invite, password",
    "noResults": "Nothing found. Try other words or write to us.",
    "popular": "Popular",
    "all": "All help articles",
    "feedback": "Report a problem",
    "feedbackSub": "One-way note to the team. We do not reply",
    "email": "Write to us",
    "emailSub": "Email support. A person answers",
    "center": "Help center",
    "centerSub": "Guides and answers, opens in a new tab",
    "report": "Report a problem",
    "reportSub": "One-way note to the team. We do not reply"
  },
  "center": {
    "title": "Help center",
    "lead": "Short answers with pictures, from first steps to the little things.",
    "back": "Back",
    "loadError": "Help articles couldn't load. Check your connection and try again.",
    "retry": "Try again",
    "empty": "Articles are on their way. Meanwhile, write to us and we'll help.",
    "minutes_one": "{{count}} min read",
    "minutes_other": "{{count}} min read",
    "notFound": "This article isn't here anymore.",
    "helpful": "Was this helpful?",
    "yes": "Yes",
    "no": "No",
    "thanks": "Thanks for telling us.",
    "stillStuck": "Still need help?",
    "stillStuckLead": "Write to us and a real person will answer.",
    "related": "More on this",
    "heroTitle": "How can we help?",
    "searchPlaceholder": "Search: reminders, invite…",
    "browse": "Browse by topic",
    "articles_one": "{{count}} article",
    "articles_other": "{{count}} articles"
  },
  "topics": {
    "getting-started": "Getting started",
    "logging": "Logging",
    "sleep-plan": "Sleep plan and reminders",
    "sounds": "Sounds and cry alert",
    "learn": "Learn",
    "chat": "Chat",
    "family": "Family and sharing",
    "account": "Account and sign-in",
    "purchases": "Purchases",
    "troubleshooting": "Something's not working"
  },
  "feedback": {
    "title": "Send feedback",
    "lead": "Tell us what works, what doesn't and what you'd like next. We read every message.",
    "rating": "How is Baby Plan for you so far?",
    "ratings": [
      "Not good",
      "Could be better",
      "Okay",
      "Good",
      "Love it"
    ],
    "kind": "What is it about?",
    "kinds": {
      "idea": "An idea or something missing",
      "problem": "Something isn't working",
      "content": "Lessons, tips or articles",
      "praise": "Something I like",
      "other": "Something else"
    },
    "message": "Your message",
    "placeholder": {
      "idea": "What would make Baby Plan more useful for you?",
      "problem": "What did you try, and what happened?",
      "content": "Which lesson or tip, and what would you change?",
      "praise": "What do you like most?",
      "other": "Write anything"
    },
    "wishes": "What would help you most next? (optional)",
    "wishList": {
      "growth_charts": "Growth charts",
      "memory_book": "Photo diary and milestones",
      "doctor_notes": "Notes for doctor visits",
      "shop": "Shop for baby products",
      "more_sounds": "More sleep sounds",
      "toddler": "More for toddlers",
      "partner_sync": "Better sharing with my partner",
      "other_language": "Other languages"
    },
    "canReply": "You can email me about this",
    "send": "Send",
    "sending": "Sending…",
    "sent": "Thank you! It's on its way to the team.",
    "error": "It didn't send. Check your connection and try again.",
    "empty": "Write a few words or pick an option first."
  },
  "email": {
    "subject": "Baby Plan help",
    "intro": "Hi Baby Plan team,\n\n\n\n",
    "details": "Details that help us (please keep):",
    "title": "Write to us",
    "lead": "A person on our team answers. Please write from the email you use for Baby Plan.",
    "copy": "Copy",
    "copied": "Copied",
    "openWith": "Write in",
    "services": {
      "gmail": "Gmail",
      "outlook": "Outlook",
      "yahoo": "Yahoo Mail",
      "app": "Mail app"
    },
    "hint": "A few details about your phone and the app are added to the message. They help us answer faster."
  },
  "access": {
    "title": "Baby Plan isn't active on this account",
    "lead": "You're signed in as {{email}}, but this account doesn't have Baby Plan right now.",
    "justBought": "Just bought it? It can take a minute to appear. Make sure you signed in with the email you paid with.",
    "invited": "Were you invited by a partner or family member? Open their invite link again, or ask them to send a new one.",
    "check": "Check again",
    "checking": "Checking…",
    "stillNo": "Still not active. Write to us and we'll sort it out.",
    "help": "Help center",
    "other": "Sign in with another email",
    "bookTitle": "Your handbooks",
    "books": {
      "first-year": "Your baby's first year",
      "second-year": "The second year",
      "third-year": "The third year",
      "sleep": "Sleep, birth to 3",
      "parents": "For you, the parent"
    },
    "bookLead": "The Baby Plan handbooks you bought are yours to keep.",
    "bookDownload": "Download PDF",
    "bookPreparing": "The PDF is being prepared. It will appear here and in Learn."
  },
  "legal": {
    "privacy": "Privacy Policy",
    "health": "Health Data Privacy",
    "terms": "Terms of Use"
  },
  "crash": {
    "title": "Something went wrong",
    "lead": "This screen hit a problem. Your logs are safe on this phone.",
    "reload": "Reload the app",
    "home": "Go to Today",
    "email": "Tell us what happened"
  },
  "viewer": {
    "title": "Picture",
    "open": "Open the picture larger: {{alt}}",
    "close": "Close",
    "prev": "Previous",
    "next": "Next",
    "count": "{{n}} of {{count}}",
    "steps_one": "{{count}} step",
    "steps_other": "{{count}} steps",
    "stepOf": "Step {{n}} of {{count}}"
  },
  "report": {
    "title": "Report a problem",
    "sentTitle": "Report sent",
    "oneWay": "This note is one-way: it goes to the team that fixes the app, and no reply comes back.",
    "needAnswer": "Need an answer? Write to us.",
    "kind": "What is it about?",
    "kinds": {
      "bug": "Something is broken",
      "content_error": "A mistake in a lesson or tip",
      "confusing": "Hard to understand",
      "missing": "Something is missing",
      "slow": "Slow or freezing",
      "idea": "An idea",
      "other": "Something else"
    },
    "text": "What happened?",
    "placeholder": "What you did, what you expected, and what happened instead.",
    "wishes": "What would help you most next? (optional)",
    "billing": "This looks like a question about payment, access or your account. Those are answered by email. Sent here, no one writes back.",
    "sendAnyway": "Send anyway",
    "send": "Send report",
    "pickKind": "Pick what the problem is about.",
    "tooShort": "Tell us a bit more. A sentence is enough.",
    "sendFailed": "It didn't send. Check your connection and try again.",
    "sentText": "Thank you. Your report is with the team that fixes the app, with the details of this screen. We read every one.",
    "noReplyBold": "No reply comes back here.",
    "noReply": "If you need an answer about your account, payment or access, write to us.",
    "writeSupport": "Write to us",
    "done": "Done",
    "signedOut": "Sign in to send a note to the team, or write to us by email."
  }
}
